import { Badge, Image } from 'react-bootstrap';
import icUserGroup from '../../assets/img/ic-user-group.svg';
import icEyeClosed from '../../assets/img/ic-eye-closed.svg';
import {
    getCommunityDisplayName,
    getCommunityPreviewText,
    formatConversationTimestamp,
    formatUnreadBadge,
} from '../../utils/conversations';

// Mobile Communities list — dedicated card tree (no table markup), following the
// mobile Discovery card blueprint: body box + footer strip underneath.
const CommunityMobileList = ({ conversations, currentUserId, onOpen, children }) => (
    <div className="mobile-company-list mobile-community-list">
        {conversations.map((conversation) => {
            const unreadLabel = formatUnreadBadge(conversation.unreadCount);
            const members = conversation.memberCount || 0;
            const typeLabel = conversation.type === 'city' ? 'City' : 'Country';

            return (
                <article
                    key={conversation._id}
                    className={`mobile-company-card mobile-community-card${unreadLabel ? ' mobile-community-card--unread' : ''}`}
                    role="button"
                    tabIndex={0}
                    onClick={() => onOpen(conversation)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            onOpen(conversation);
                        }
                    }}
                >
                    <div className="mobile-company-card__body mobile-community-card__body">
                        <div className="mobile-community-card__top">
                            <span className="mobile-community-card__avatar" aria-hidden="true">
                                <Image src={icUserGroup} alt="" />
                            </span>
                            <div className="mobile-community-card__heading">
                                <h3 className="mobile-company-card__title mb-0">{getCommunityDisplayName(conversation)}</h3>
                                <p className="mobile-community-card__meta">
                                    <span>{typeLabel} · {members} {members === 1 ? 'member' : 'members'}</span>
                                    {conversation.isReadOnly && (
                                        <span className="mobile-community-card__readonly">
                                            <Image src={icEyeClosed} alt="" /> Read-only
                                        </span>
                                    )}
                                </p>
                            </div>
                            {unreadLabel && (
                                <Badge bg="primary" pill className="community-unread-badge">{unreadLabel}</Badge>
                            )}
                        </div>
                    </div>
                    <div className="mobile-community-card__footer">
                        <span className="mobile-community-card__preview">{getCommunityPreviewText(conversation, currentUserId)}</span>
                        <span className="mobile-community-card__time">
                            {formatConversationTimestamp(conversation.lastMessageAt || conversation.createdAt)}
                        </span>
                    </div>
                </article>
            );
        })}
        {children}
    </div>
);

export default CommunityMobileList;
